import React, { Fragment, useState, useEffect } from 'react'
import { Form, Input, Button, Space, Skeleton, Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { postData } from '../../../Actions/Action'
import types from '../../../Stores/types'

function ConnectionSettingsComponent(props) {
	const [testType, setTestType] = useState(false)
	const [apiTypeOverride, setApiTypeOverride] = useState(null)
	const dispatch = useDispatch()
	const { connectionSettings, token, carrierId, isInstalling } = useSelector(state => state)

	const handleTypeChange = type => setTestType(type)

	useEffect(() => {
		if (connectionSettings) {
			const hasExistingCredentials = !!(connectionSettings.username || connectionSettings.customer_number)
			const defaultApiType = hasExistingCredentials ? 'soap_api' : 'rest_api'
			const savedApiType = connectionSettings.api_type ?? defaultApiType
			dispatch({ type: types.SET_ESTES_API_TYPE, payload: savedApiType })
		}
	}, [connectionSettings, dispatch])

	const onFinish = values => {
		values = {
			...values,
			account_number: apiType === 'rest_api' ? values.account_number : undefined,
			customer_number: apiType === 'soap_api' ? values.account_number : undefined,
			testType,
			carrierId,
			installed_carrier_id: carrierId,
			api_type: apiType,
		}

		dispatch(
			postData(
				values,
				'GET_CONNECTION_SETTINGS',
				'submit_connection_settings',
				token
			)
		)
	}

	if (!connectionSettings) return <Skeleton active />

	const hasExistingCredentials = !!(connectionSettings.username || connectionSettings.customer_number)
	const defaultApiType = hasExistingCredentials ? 'soap_api' : 'rest_api'
	const apiType = apiTypeOverride ?? connectionSettings.api_type ?? defaultApiType

	const cleanedInitialValues = {
		...connectionSettings,
		api_type: apiType,
		account_number: connectionSettings.account_number || connectionSettings.customer_number || '',
		password: connectionSettings.password === 'RLSsKFvFmcFUFpvzZtaMmySP2'
			? ''
			: connectionSettings.password,
	}

	const accountLabel = apiType === 'soap_api' ? 'Customer Number' : 'Account Number'
	const accountPlaceholder = apiType === 'soap_api' ? 'e.g. 12345678' : 'e.g. 123456789'

	return (
		<Fragment>
			<div className={'note-bx'}>
				<strong>Note!</strong> You must have an Estes Express
				account to use this application. If you do not have one, contact
				Estes Express at 866-378-3748, or email{' '}
				<a
					href='mailto:customercare@estes-express.com'
					target='_blank'
					rel='noreferrer'>
					customercare@estes-express.com
				</a>
				.
			</div>

			{apiType === 'rest_api' && (
				<div className={'note-bx'}>
					<strong>Important for REST API Users:</strong> The Estes REST API
					uses case-sensitive credentials. If you previously used the SOAP API,
					your username and password may have worked even when uppercase and
					lowercase letters were entered incorrectly. In the REST API, the
					username and password must match exactly as provided by Estes. If the
					connection test fails after switching to the REST API, verify that
					your Estes username and password are entered using the correct
					uppercase and lowercase letters.
				</div>
			)}

			<Form
				layout='vertical'
				name='connection_settings'
				className='connection-settings'
				size='large'
				initialValues={cleanedInitialValues}
				onFinish={onFinish}>

				<Form.Item
					className='mb-1'
					label='Nickname'
					name='nickname'
					required={true}
					rules={[{ required: !testType, message: 'Nickname is required' }]}>
					<Input placeholder='e.g. Estes West' />
				</Form.Item>

				<Form.Item
					label='Which API Will You Connect To?'
					name='api_type'>
					<Select
						options={[
							{ label: 'REST API', value: 'rest_api' },
							{ label: 'SOAP API', value: 'soap_api' },
						]}
						onChange={opt => {
							setApiTypeOverride(opt)
							dispatch({
								type: types.SET_ESTES_API_TYPE,
								payload: opt,
							})
						}}
					/>
				</Form.Item>

				{/* SOAP: Customer Number above Username */}
				{apiType === 'soap_api' && (
					<Form.Item
						label={accountLabel}
						name='account_number'
						required={true}
						rules={[{ required: true, message: `${accountLabel} is required` }]}>
						<Input placeholder={accountPlaceholder} />
					</Form.Item>
				)}

				<Form.Item
					label='Username'
					name='username'
					required={true}
					rules={[{ required: true, message: 'Username is required' }]}>
					<Input placeholder='e.g. john.smith' />
				</Form.Item>

				<Form.Item
					className='mb-1'
					label='Password'
					name='password'
					required={true}
					rules={[{ required: true, message: 'Password is required' }]}>
					<Input type='text' placeholder='Enter password' />
				</Form.Item>

				{/* REST: Account Number below Password */}
				{apiType === 'rest_api' && (
					<Form.Item
						label={accountLabel}
						name='account_number'
						required={true}
						rules={[{ required: true, message: `${accountLabel} is required` }]}>
						<Input placeholder={accountPlaceholder} />
					</Form.Item>
				)}

				<div style={{ marginTop: '8px' }}>
					<a
						href='https://eniture.com/bigcommerce-estes-connection-instructions/'
						target='_blank'
						rel='noreferrer'>
						How to obtain your Estes account credentials?
					</a>
				</div>

				<Form.Item style={{ textAlign: 'right', marginBottom: '0' }}>
					<Space>
						<Button
							type='primary'
							size='large'
							htmlType='submit'
							name='test'
							onClick={() => handleTypeChange(true)}>
							Test Connection
						</Button>
						<Button
							type='primary'
							size='large'
							htmlType='submit'
							name='save'
							onClick={() => handleTypeChange(false)}>
							Save Settings
						</Button>
					</Space>
				</Form.Item>
			</Form>
		</Fragment>
	)
}

export default ConnectionSettingsComponent
